import React, { useEffect, useState } from "react";
import { Alert, Button, Checkbox, Form, Input, Select, Spin, message } from "antd";
import { createSprServis, fetchSprServis, saveSprServis } from "./spr-servis-api";
import { CDA_OPTIONS, VID_DIARY, normalizeServis } from "./spr-servis-utils";

const LABEL_WIDTH = 140;

const formItemLayout = {
  labelCol: { flex: `0 0 ${LABEL_WIDTH}px` },
  wrapperCol: { flex: "1 1 auto" },
  labelAlign: "right"
};

/**
 * Форма карточки SPR_SERVIS (Delphi TFrmGetStr / TFrmESprServiceCons).
 */
const SprServisMain = ({ vid, id, isNew, open, canEdit, onSaved, onCancel }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const isDiary = vid === VID_DIARY;

  useEffect(() => {
    if (!open) return undefined;
    setError("");

    let cancelled = false;

    if (isNew) {
      form.resetFields();
      form.setFieldsValue({
        name: "",
        isOk: false,
        id1: 0
      });
      return () => {
        cancelled = true;
      };
    }

    if (id == null || vid == null) return undefined;

    setLoading(true);
    fetchSprServis(vid, id)
      .then((data) => {
        if (cancelled) return;
        const row = normalizeServis(data);
        if (row.id == null) {
          setError("Запись не найдена");
          return;
        }
        form.setFieldsValue({
          id: row.id,
          name: row.name,
          isOk: row.isOk === 1,
          id1: row.id1 ?? 0
        });
      })
      .catch((e) => {
        if (!cancelled) setError(e.message || "Не удалось загрузить");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [open, isNew, id, vid, form]);

  const onFinish = async (values) => {
    if (!canEdit) return;
    setSaving(true);
    setError("");
    const body = {
      vid,
      name: (values.name || "").trim(),
      isOk: isDiary && values.isOk ? 1 : 0,
      id1: isDiary ? values.id1 ?? 0 : 0
    };
    try {
      const saved = isNew
        ? await createSprServis(body)
        : await saveSprServis({ ...body, id });
      message.success("Сохранено");
      onSaved?.(saved);
    } catch (e) {
      setError(e.message || "Не удалось сохранить");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="spr-servis-card__center">
        <Spin />
      </div>
    );
  }

  return (
    <div className="spr-servis-card">
      <div className="spr-servis-card__body">
        {error ? (
          <Alert type="error" showIcon message={error} style={{ marginBottom: 12 }} />
        ) : null}
        <Form
          form={form}
          className="spr-servis-card__form"
          {...formItemLayout}
          colon={false}
          onFinish={onFinish}
          requiredMark={false}
          disabled={!canEdit}
        >
          {!isNew ? (
            <Form.Item label="Код" name="id">
              <Input disabled />
            </Form.Item>
          ) : null}
          <Form.Item
            label="Наименование"
            name="name"
            rules={[{ required: true, message: "Укажите наименование" }]}
          >
            <Input maxLength={80} autoFocus={isNew || canEdit} />
          </Form.Item>
          {isDiary ? (
            <>
              <Form.Item label=" " colon={false}>
                <Form.Item name="isOk" valuePropName="checked" noStyle>
                  <Checkbox>Разделы</Checkbox>
                </Form.Item>
              </Form.Item>
              <Form.Item label="Вид CDA" name="id1">
                <Select options={CDA_OPTIONS} />
              </Form.Item>
            </>
          ) : null}
        </Form>
      </div>
      <div className="spr-servis-card__footer">
        {canEdit ? (
          <Button type="primary" loading={saving} onClick={() => form.submit()}>
            Сохранить
          </Button>
        ) : null}
        <Button onClick={onCancel} disabled={saving}>
          Отмена
        </Button>
      </div>
    </div>
  );
};

export default SprServisMain;
